export default function TableRow({ children, className = '', onClick }) {
  return (
    <tr className={`bidder-table-row ${className}`} onClick={onClick}>
      {children}
    </tr>
  );
}
